import { Navigate } from 'react-router-dom'

interface Props {
  children: React.ReactNode
}

function AuthGuard({ children }: Props) {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

export default AuthGuard
